import $ from "jquery"
import _ from "underscore"
import messageResource from "../../../messageResource"
import {getStringWithUnifiedNewLineSymbol, trim} from "../../../atUtils"
import {setFocusIntoFieldWithPlaceholder} from "../../../atBrowserUtils"
import AssignedUsersEditor from "../../../panels/usersAssignedToHierarchy/AssignedUsersEditor"
import AssignedUsersEditorChangesHandler from "../AssignedUsersEditorChangesHandler"
import ProxyView from "../../../util/ProxyView"
import TabHeaders from "../TabHeaders"
import LoadingContainer from "../../../util/LoadingContainer"
import {customerActionsProvider} from "../../../panels/actionsProviders"
import {addDefaultUserGroup} from "../../../util/groupUtils"
import AssignedUsersEditorContainer from "../../../panels/usersAssignedToHierarchy/AssignedUsersEditorContainer"
import {PROJECT_CONSTANTS} from './constants'

import TemplateView from '../../../TemplateView'
import ImportTasksSelector from "../ImportTasksSelector"
import TaskTableTemplate from "../TaskTableTemplate"
import ImportTasksSelectorButton from "../ImportTasksSelectorButton"
import TabsController from '../../../panels/TabsController'
import {isEnabled} from '../../../features/utils'
import {Feature} from '../../../features'
import {EntityTextLimits} from 'constants'
import CPCombobox from '../../components/CPCombobox'
import {Description} from '../../../panels/Description'

const TAB_KEYS = {
    DETAILS: 'details',
    ASSIGNED_USERS: 'assignedUsers',
    MANAGERS: 'managers'
};

export default class CreateProjectContent extends TemplateView {
    constructor({
                    customersInfo,
                    customerId,
                    billingTypes,
                    enabledFeatures,
                    defaultBillingTypeId,
                    weekStartDay,
                    scheduleCalculator,
                    projectsWithTasksExist,
                    user,
                    isPossibleToCreateCustomer,
                },
                {
                    onCustomerSelected = () => {},
                    onCustomerNameChanged = () => {},
                    onProjectNameChanged = () => {},
                    onProjectNameBlur = () => {},
                    onCustomerNameBlur = () => {},
                    onChangeCallback = () => {},
                    onDescriptionFieldChange = () => {},
                    onValidateCallback = () => {},
                    getScrollPositionCallback = () => 0,
                    refreshScrollCb = () => {},
                }) {
        super(null);

        this.params = {
            customersInfo,
            customerId,
            billingTypes,
            enabledFeatures,
            defaultBillingTypeId,
            weekStartDay,
            scheduleCalculator,
            projectsWithTasksExist,
            user,
            isPossibleToCreateCustomer,
        }

        this.callbacks = {
            onCustomerSelected,
            onCustomerNameChanged,
            onProjectNameChanged,
            onProjectNameBlur,
            onCustomerNameBlur,
            onChangeCallback,
            onDescriptionFieldChange,
            onValidateCallback,
            getScrollPositionCallback,
            refreshScrollCb,
        }

        this.updateOnInit = true

        this.state = {
            currentTabKey: null,
            selectedCustomerId: PROJECT_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX,
        }
        this.onStatePropertyChanged('currentTabKey', this._handleTabSwitched)

        this.onStatePropertyChanged('selectedCustomerId', (id) => {
            this.customersSelector.setState({selectedItemId: id})
        })
    }

    templateHtml() {
        return '<div class="innerContent">' +
               '    <div class="projectSection">' +
               '        <div class="sectionDetails">' +
               '            <input maxlength="<%=maxNameLength%>"  tabindex="1" type="text" class="projectNameField inputFieldWithPlaceholder inputNameField"' +
               '                   placeholder="<%-projectNamePlaceholder%>"/>' +
               '            <div class="projectNameErrorWrapper">' +
               '                <div class="projectNameError"><%-emptyName%></div>' +
               '                <div class="projectDuplicateNameError"><%-projectExists%></div>' +
               '            </div>' +
               '            <div class="customerContainer">' +
               '                <div class="customerLabel"><%-customer%>:</div>' +
               '                <div class="customerSelectorPlaceholder selectorWithPlaceholderContainer"></div>' +
               '                <input maxlength="<%=maxNameLength%>" tabindex="2" type="text" class="newCustomerNameField newCustomer"' +
               '                       placeholder="<%=customerNamePlaceholder%>"/>' +
               '                <div class="customerNameErrorWrapper">' +
               '                    <div class="customerSelectorError"><%-customerNotSelected%></div>' +
               '                    <div class="emptyCustomerNameError"><%-customerEmptyName%></div>' +
               '                    <div class="duplicateCustomerNameError"><%-customerExists%></div>' +
               '                </div>' +
               '            </div>' +
               '            <div class="projectDescriptionField">' +
               '                <div class="descriptionLabel"><%-descriptionLabel%></div>' +
               '            </div>' +
               '        </div>' +
               '        <div class="taskTable">' +
               '            <div class="importTasksHeader">' +
               '                <div class="title"><%-importTasksHeader%></div>' +
               '                <div class="importTasksSelectorButtonContainer"></div>' +
               '            </div>' +
               '            <div class="taskTablePlaceholder"></div>' +
               '        </div>' +
               '    </div>' +
               '</div>'
    }

    templateModel() {
        return {
            maxNameLength: EntityTextLimits.MAX_CPT_NAME,
        }
    }

    messageKeys() {
        return {
            projectNamePlaceholder: 'project.common.projectNamePlaceholder',
            deleteBtn: 'project.edit.js.delete_button_caption',
            emptyName: 'project.common.errormsg.empty_name',
            projectExists: 'project.common.errormsg.project_exists',
            editStatus: 'project.edit.status',
            customer: 'project.common.customer',
            customerNamePlaceholder: 'project.common.customerNamePlaceholder',
            customerNotSelected: 'project.common.errormsg.customer_not_selected',
            customerEmptyName: 'project.common.customer.empty_name',
            customerExists: 'project.common.errormsg.customer_exists',
            descriptionLabel: 'panel.common.description',
            importTasksHeader: 'project.edit.add_tasks'
        }
    }

    afterRender() {
        const self = this;
        this._innerContentEl = this.$el;

        this._isInstantValidation = true;
        this.sectionEl = this.find(".sectionDetails");
        this.commitButtonTitlePlaceholder = self.find(".commitBtn").find(".buttonTitle");

        this.projectNameField = this.find(".projectNameField");
        this.descriptionField = this.find(".projectDescriptionField");
        this.newCustomerField = this.find(".newCustomerNameField");

        this.titlePlaceholder = this.find(".titlePlaceholder")[0];
        this.projectNameError = this.find(".projectNameError")[0];

        this.customerSelectorContainer = this.find(".customerContainer")[0];
        this.customerSelectorError = this.find(".customerSelectorError")[0];
        this.$customerSelectorPlaceHolder = this.find(".customerSelectorPlaceholder")

        const tabHeaders = new TabHeaders().init($("<div></div>").insertBefore(this.$el.parent().parent()));

        const assignedUsersEditor = new LoadingContainer({
            contentComponent: new AssignedUsersEditor({
                onUserDelete: userData => this.assignedUsersEditorChangesHandler.handleUserDelete(userData.id),
                onAssignedUsersChange: ({addedUserIds, removedUserIds}) => this.assignedUsersEditorChangesHandler.handleAssignedUsersChange(addedUserIds,
                    removedUserIds),
                titleMessageKey: "assigned_users_editor.project.title",
                userSubtitleGenerator: (user) => {
                    if (user.hasAllAssignments) {
                        return messageResource.getMessage("assigned_users_editor.project.has_all_assignments")
                    } else if (user.hasCustomerAssignment) {
                        return messageResource.getMessage("assigned_users_editor.project.has_customer_assignment")
                    }
                },
                managersMessageKey: "assigned_users_editor.project.managers_count",
                canEditManagers: false,
                addUsersMessageKey: "assigned_users_editor.add_title",
                emptyListMessageKey: "assigned_users_editor.project.empty_list",
                showPermissionIcons: false,
                checkIfCanModify: user => !user.hasManageAssignment,
                getListDisabledTooltipText: user => this._getDisabledTooltipText(user),
                getSelectorDisabledTooltipText: user => this._getDisabledTooltipText(user),
                renderUserSelectorToContent: true,
                refreshScrollCb: this.callbacks.refreshScrollCb,
            }),
            containerClass: "assignedUsersTab"
        }).init(this.$el);
        this.assignedUsersEditorContainer = new AssignedUsersEditorContainer({
            assignedUsersEditor: assignedUsersEditor,
            $tabTitle: tabHeaders.$assignedUsersTabTitle,
            tabTitleMessageKey: "task.edit_panel.tabs.assigned_users_with_count"
        }).init();
        this.assignedUsersEditorChangesHandler = new AssignedUsersEditorChangesHandler({
            editor: this.assignedUsersEditorContainer,
            assignedUserModelExtender: assigned => ({hasProjectAssignment: assigned}),
            changeCallback: () => this.callbacks.onChangeCallback(),
        })

        const managersEditor = new LoadingContainer({
            contentComponent: new AssignedUsersEditor({
                onUserDelete: userData => this.managersEditorChangesHandler.handleUserDelete(userData.id),
                onAssignedUsersChange: ({addedUserIds, removedUserIds}) => this.managersEditorChangesHandler.handleAssignedUsersChange(addedUserIds,
                    removedUserIds),
                titleMessageKey: "assigned_users_editor.managers.project.title",
                userSubtitleGenerator: (user) => {
                    if (user.hasAllAssignments) {
                        return messageResource.getMessage("assigned_users_editor.managers.project.has_all_assignments")
                    } else if (user.hasCustomerAssignment) {
                        return messageResource.getMessage("assigned_users_editor.managers.project.has_customer_assignment")
                    }
                },
                addUsersMessageKey: "assigned_users_editor.managers.add_title",
                showPermissionIcons: true,
                checkIfCanModify: user => !(user.hasAllAssignments || user.hasCustomerAssignment || user.hasAllFutureProjectsOfCustomerAssignment),
                getListDisabledTooltipText: user => this._getDisabledTooltipText(user),
                getSelectorDisabledTooltipText: user => this._getDisabledTooltipText(user),
                renderUserSelectorToContent: true,
                refreshScrollCb: this.callbacks.refreshScrollCb,
            }),
            containerClass: "managersTab"
        }).init(this.$el);
        managersEditor.setState({
            isBTYEnabled: isEnabled(this.params.enabledFeatures, Feature.BTY),
            isURAEnabled: isEnabled(this.params.enabledFeatures, Feature.URA),
            isTTAEnabled: isEnabled(this.params.enabledFeatures, Feature.TTA),
        })

        this.managersEditorContainer = new AssignedUsersEditorContainer({
            assignedUsersEditor: managersEditor,
            $tabTitle: tabHeaders.$managersTabTitle,
            tabTitleMessageKey: "task.edit_panel.tabs.managers_with_count"
        }).init();
        this.managersEditorChangesHandler = new AssignedUsersEditorChangesHandler({
            editor: this.managersEditorContainer,
            assignedUserModelExtender: assigned => ({hasProjectAssignment: assigned}),
            changeCallback: () => this.callbacks.onChangeCallback(),
        })

        this._refreshAssignmentsData(this.params.customerId)

        let tabs = new Map([
            [TAB_KEYS.DETAILS, new ProxyView(this.find('.projectSection'))],
            [TAB_KEYS.ASSIGNED_USERS, assignedUsersEditor],
            [TAB_KEYS.MANAGERS, managersEditor]
        ])

        tabs.forEach(($tab, tabKey) => {
            $tab.hide()
        })

        this.tabsController = new TabsController({
            tabs: tabs,
        }).init()

        this.buttons = new Map([
            [TAB_KEYS.DETAILS, tabHeaders.$detailsTabHeader],
            [TAB_KEYS.ASSIGNED_USERS, tabHeaders.$assignedUsersTabHeader],
            [TAB_KEYS.MANAGERS, tabHeaders.$managersTabHeader]
        ])

        this.buttons.get(TAB_KEYS.ASSIGNED_USERS).toggle(isEnabled(this.params.enabledFeatures, Feature.WAS))

        this.buttons.forEach(($button, key) => {
            $button.click(() => {
                this.openTabByKey(key)
            })
        })

        this.initCustomerSelector(this.params.customersInfo, this.params.customerId);
        this.initTextAreaLengthNote();

        this.projectNameField.off();
        this.descriptionField.off();
        this.newCustomerField.off();

        this.keyUpChangesHandler = function(additionalHandler) {
            return function() {
                this.keyPressed = false;
                if ((!this.prevValue && !!this.value) || this.prevValue !== this.value)
                    self.callbacks.onChangeCallback();

                if (additionalHandler)
                    additionalHandler();
            }
        };
        this.onBlurFieldHandler = function(additionalHandler) {
            return function() {
                $(this).pVal(trim(this.value));
                //see Bug 48539
                if (this.keyPressed) self.keyUpChangesHandler.call(this);

                if (additionalHandler)
                    additionalHandler();
            };
        };

        this.onKeyPressedHandler = function() {
            this.keyPressed = true;
        };


        this.projectNameField.keydown(this.onKeyPressedHandler());
        this.projectNameField.blur(this.onBlurFieldHandler(() => {
            this.callbacks.onProjectNameBlur(this.projectNameField)
        }));
        this.projectNameField.keyup(this.keyUpChangesHandler());
        this.projectNameField.change(function() {
            self.callbacks.onProjectNameChanged()
        });

        this.descriptionInput = new Description({
            onChange: (description) => {
                this.descriptionInput.setState({
                    text: description,
                })
                this.callbacks.onDescriptionFieldChange(description)
                this.callbacks.onChangeCallback()
            },
            onKeyDown: () => this.onKeyPressedHandler(),
        }).init(this.descriptionField)

        this.descriptionInput.setState({
            placeholder: messageResource.getMessage('project.common.projectDescriptionPlaceholder'),
            editable: true,
        })

        this.newCustomerField.keydown(this.onKeyPressedHandler());
        this.newCustomerField.blur(this.onBlurFieldHandler(() => {
            this.callbacks.onCustomerNameBlur(this.newCustomerField)
        }));
        this.newCustomerField.keyup(this.keyUpChangesHandler());
        this.newCustomerField.change(function() {
            self.callbacks.onCustomerNameChanged()
        });

        this.initCreateTasksComponent();

        this.importTasksSelector = new ImportTasksSelector($("body"), {
            scrollableContainer: this._innerContentEl,
            canSelectAllInCustomer: true,
            canSelectAllInProject: true,
            selectionCallback: ({taskIds, customerId, projectId, importDescriptions, importOnlyActiveProjects}) => {
                this.createTasksComponent.importTasksRequest(taskIds, importDescriptions, customerId, projectId, importOnlyActiveProjects);
                this.importTasksSelector.hidePanel()
            }
        }).init();
        this.importTasksSelector.setState({
            user: this.params.user
        });

        const importTasksSelectorButton = new ImportTasksSelectorButton(() => {
            this.importTasksSelector.showPanel({of: importTasksSelectorButton.$el})
        }).init(this.find(".importTasksSelectorButtonContainer"));

        this.initPlaceholders();

        return this;
    }

    update() {
        this.openTabByKey(TAB_KEYS.DETAILS)
    }

    openTabByKey(key) {
        this.setState({currentTabKey: key})
    }

    _handleTabSwitched = (selectedKey, previousKey) => {
        this.tabsController.setState({selectedTabKey: selectedKey})

        if (previousKey) this.buttons.get(previousKey).toggleClass('selected', false)
        this.buttons.get(selectedKey).toggleClass('selected', true)
    }

    _getDisabledTooltipText(user) {
        let msg = messageResource.getMessage(
            'assigned_users_editor.managers.disabled_tooltip',
            [
                messageResource.getMessage('common.project'),
                user.firstName,
            ]
        )

        if (user.hasAllAssignments) {
            msg += " " + messageResource.getMessage('assigned_users_editor.managers.disabled_tooltip.entire_scope')
        }  else if (user.hasAllFutureProjectsOfCustomerAssignment) {
            msg += " " + messageResource.getMessage(
                'assigned_users_editor.managers.disabled_tooltip.all_existing_and_future_items_assignment',
                [
                    messageResource.getMessage('common.projects'),
                    messageResource.getMessage('common.customer'),
                ]
            )
        } else if (user.hasCustomerAssignment) {
            msg += " " + messageResource.getMessage(
                'assigned_users_editor.managers.disabled_tooltip.entire_item_assignment',
                [messageResource.getMessage('common.customer')],
            )
        }
        return msg
    }

    setErrorClasses(classes) {
        this.find('.sectionDetails').removeClass().addClass(classes).addClass('sectionDetails')
    }

    getProjectNameField() {
        return this.projectNameField
    }

    getCustomerNameField() {
        return this.newCustomerField
    }

    getDescriptionField() {
        return this.descriptionField
    }

    getCustomerSelectorSection() {
        return $(this.customerSelectorContainer)
    }

    validateDescription() {
        return this.descriptionInput.invalid;
    }

    getCreateTaskComponent() {
        return this.createTasksComponent;
    }

    applyAssignmentsData(editor, editorChangesHandler, actionResult, hideAssignButtonStateExtender = (state) => state) {
        editor.setState({loading: true});
        actionResult
            .then(({
                       users,
                       userGroups,
                       timeZoneGroups,
                       userGroupsEnabled,
                       timeZoneGroupsEnabled,
                       canModifyAny
                   }) => {
                let state = editorChangesHandler.extendEditorState({
                    users: users.map(user => ({...user, canBeModified: user.canBeModified && !user.hasCustomerAssignment})),
                    userGroups: (userGroups) ? addDefaultUserGroup(userGroups) : userGroups,
                    timeZoneGroups,
                    userGroupsEnabled,
                    timeZoneGroupsEnabled,
                    canModifyAny,
                    loading: false
                })
                state = hideAssignButtonStateExtender(state)
                editor.setState(state)
            })
            .catch(e => {
                editor.setState({loading: false})
                console.error(e);
            })
    }

    initCreateTasksComponent() {
        const defaultRowsNumber = 3;
        this.createTasksComponent = new TaskTableTemplate(
            this.find(".taskTablePlaceholder"),
            {
                billingTypes: this.params.billingTypes,
                showBillingTypeColumn: isEnabled(this.params.enabledFeatures, Feature.BTY),
                defaultBillingTypeId: this.params.defaultBillingTypeId,
                canAddTasksToUser: false,
                weekStartDay: this.params.weekStartDay,
                scheduleCalculator: this.params.scheduleCalculator,
                estEnabled: isEnabled(this.params.enabledFeatures, Feature.EST),
                tstEnabled: isEnabled(this.params.enabledFeatures, Feature.TST),
                defaultRowsNumber: defaultRowsNumber,
                isOpenedFromOpenTasks: true,
                changesCallback: this.callbacks.onChangeCallback,
                validateCallback: this.callbacks.onValidateCallback,
                scrollableContainer: this._innerContentEl,
                getScrollPositionCallback: this.callbacks.getScrollPositionCallback,
                refreshScrollCb: this.callbacks.refreshScrollCb,
            }).init();
    }

    getNewProjectData() {
        const tasks = this.createTasksComponent.getTasks();
        return [
            {
                customerId: this.getCustomerId(),
                customerName: this.getCustomerName(),
                name: this.getProjectName(),
                description: this.getDescription()
            },
            tasks,
            this.assignedUsersEditorChangesHandler.getAddedUserIds(),
            this.managersEditorChangesHandler.getAddedUserIds()
        ]
    }

    show() {
        super.show();
        setFocusIntoFieldWithPlaceholder(this.projectNameField);
    }

    hide() {
        this.createTasksComponent.hideDescriptionPopup();
        this.createTasksComponent.restoreGetOnPageDescriptionFunction();
        super.hide();
    }

    commit() {
        if (this.createTasksComponent.hideDescriptionPopup(true))
            super.commit();
    }

    initPlaceholders() {
        this.projectNameField.placeholder();
        this.newCustomerField.placeholder();
    }

    getProjectName() {
        return this.projectNameField.pVal();
    }

    getDescription() {
        return this.descriptionInput.getText();
    }

    getCustomerName() {
        return this.newCustomerField.pVal();
    }

    getCustomerId() {
        return this.state.selectedCustomerId;
    }

    initCustomerSelector(customerInfos, customerId) {
        const items = [];
        const additionalItems = [];
        this.$customerSelectorPlaceHolder.empty()

        if (customerId <= 0) {
            customerId = PROJECT_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX;
        }

        const newCustomerIndex = PROJECT_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX;

        if (this.params.isPossibleToCreateCustomer) {
            additionalItems.push({id: newCustomerIndex, name: messageResource.getEscapedMessage("project.common.new_customer")});
        }

        if (customerInfos.length === 0)
            customerId = newCustomerIndex;

        customerInfos.forEach(info => {
            items.push({id: info.id, name: info.name});
        })

        const handler = customerId => {
            this.resetCustomerSelectorClasses()
            this.callbacks.onCustomerSelected(customerId)

            if (customerId === PROJECT_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX) {
                this.focusNewCustomerField()
            }

            if (customerId === PROJECT_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX) {
                this.highlightCustomerSelector()
            }

            this._refreshAssignmentsData(customerId)

            this.callbacks.onChangeCallback()
        };

        this.customersSelector = new CPCombobox({
            emptySelectionMessageKey: "project.common.please_select_one",
            notFoundMessageKey: "task.list.move_to.no_customers_found",
            hiddenItemsCollapsedMessageKey: 'task.list.move_to.show_archived_customers',
            hiddenItemsExpandedMessageKey: 'task.list.move_to.hide_archived_customers',
            emptyListMessageKey: "task.list.move_to.no_customers",
            onItemSelectedCb: (entity) => {
                this.setState({
                    selectedCustomerId: entity.id,
                })
                this.customersSelector.setState({selectedItemId: entity.id})
                handler(entity.id)
            },
        }).init($(this.$customerSelectorPlaceHolder))
        this.setState({
            selectedCustomerId: customerId,
        })
        this.customersSelector.setState({
            items: items,
            additionalItems: additionalItems,
            selectedItemId: customerId,
        })

        this.highlightCustomerSelector();
    }

    _refreshAssignmentsData(customerId) {
        if (isEnabled(this.params.enabledFeatures, Feature.WAS)) {
            this.applyAssignmentsData(this.assignedUsersEditorContainer, this.assignedUsersEditorChangesHandler,
                customerId > 0 ? customerActionsProvider.getAssignedUsers(customerId) : customerActionsProvider.getAssignedUsersForAll());
        }
        this.applyAssignmentsData(this.managersEditorContainer, this.managersEditorChangesHandler,
            customerId > 0 ? customerActionsProvider.getManagers(customerId) : customerActionsProvider.getManagersForAll(),
            state => ({
                ...state,
                hideAssignButton: !state.canModifyAny
            }));
    }

    resetCustomerSelectorClasses() {
        $(this.customerSelectorContainer).removeClass("newCustomer");
        this.$customerSelectorPlaceHolder.removeClass("notSelected");
    }

    // TODO state
    focusNewCustomerField() {
        $(this.customerSelectorContainer).addClass("newCustomer");
        setFocusIntoFieldWithPlaceholder(this.newCustomerField);
    }

    // TODO state
    highlightCustomerSelector() {
        this.$customerSelectorPlaceHolder.addClass("notSelected");
    }


    initTextAreaLengthNote() {
        const self = this;
        // TODO find id
        /*this.descriptionLengthNote = new TextAreaLengthNote('projectPopup_projectDescription', 'Description', 2000);
        this.descriptionLengthNote.setTextLengthCounter(this.descriptionLengthNote.fullCounter);
        this.descriptionLengthNote.update(this.getDescriptionForUpdatingLengthNote());
        this.descriptionLengthNote.show();*/
    }

    getDescriptionForUpdatingLengthNote() {
        return trim(getStringWithUnifiedNewLineSymbol(this.getDescription()));
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/createLightbox/project/CreateProjectContent.js